'use client';

var __jsx = React.createElement;
import React, { useEffect, useState } from "react";
import 'styles/layout/header.css';
import { HeaderActions, HeaderAvailablePointsDisplay, HeaderEntityLogo } from "./components";
import { useCustomer } from "@lib/context/shared/customer-context";
import HeaderAuthButtons from "./components/auth-buttons";
import { usePathname } from "next/navigation";
import { cn } from "@lib/cn";
import { BREAKPOINTS } from "@lib/constants";
import { useMediaQuery } from "react-responsive";
import APP_CONFIGURATION from "@lib/app.config";
import { useTranslations } from "next-intl";
import demoStoryblokService from "@lib/storyblok/services/demo-service/demo-service";
import Image from "next/image";
import PageContainer from "../shared/container";
import { permissionsManager } from "@lib/permissions/permissions-manager";
import useMuscleRouter from "@lib/hooks/use-muscle-router";
import { useIsLoadingResources } from "@lib/context/shared/loading-resources-context";
const Header = _ref => {
  var _APP_CONFIGURATION$co, _APP_CONFIGURATION$co2, _APP_CONFIGURATION$co3, _APP_CONFIGURATION$co4;
  let {
    onClickLogo,
    additionalButtons = __jsx(React.Fragment, null),
    additionalDropdownItems = [],
    hideContent = false
  } = _ref;
  const {
    customerIsLogged,
    isLoadingCustomer,
    customerIsValidated,
    allowUnauthenticatedCustomer,
    isSessionProviderActive
  } = useCustomer();
  const pathname = usePathname();
  const maintenanceActive = process.env.NEXT_PUBLIC_SHOW_LANDING_MAINTENANCE === 'true' && (localStorage ? localStorage.getItem("qa_admin") !== "true" : true);
  // With entity login only for explore
  const withEntityLogin = permissionsManager.useEntityLogin();
  const isTablet = useMediaQuery({
    query: "(max-width: ".concat((_APP_CONFIGURATION$co = (_APP_CONFIGURATION$co2 = APP_CONFIGURATION.config.screensConfig) === null || _APP_CONFIGURATION$co2 === void 0 ? void 0 : _APP_CONFIGURATION$co2.md) !== null && _APP_CONFIGURATION$co !== void 0 ? _APP_CONFIGURATION$co : "".concat(BREAKPOINTS.md, "px"), ")")
  });
  const forceShowPoints = process.env.NEXT_PUBLIC_FORCE_SHOW_POINTS === "true";
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat((_APP_CONFIGURATION$co3 = (_APP_CONFIGURATION$co4 = APP_CONFIGURATION.config.screensConfig) === null || _APP_CONFIGURATION$co4 === void 0 ? void 0 : _APP_CONFIGURATION$co4.sm) !== null && _APP_CONFIGURATION$co3 !== void 0 ? _APP_CONFIGURATION$co3 : "".concat(BREAKPOINTS.sm, "px"), ")")
  });
  const demoT = useTranslations("Demos");
  const {
    0: headerImage,
    1: setHeaderImage
  } = useState(null);
  const muscleRouter = useMuscleRouter();
  const {
    setIsLoadingPage
  } = useIsLoadingResources();
  useEffect(() => {
    const loadHeaderImage = async () => {
      const image = await demoStoryblokService.getHeaderImage();
      setHeaderImage(image || null);
    };
    loadHeaderImage();
  }, []);
  return __jsx("div", {
    className: "header headerDynamicStyle header-background"
  }, __jsx(PageContainer, {
    className: "m-0 p-0"
  }, __jsx("div", {
    // className='header-content global-responsive-horizontal-paddings'
    className: cn('header-content   !py-0 !w-full', maintenanceActive && 'justify-center md:justify-start')
  }, __jsx("div", {
    className: "flex flex-row  gap-x-2 flex-wrap h-full items-center md:gap-x-0"
  }, __jsx(HeaderEntityLogo, {
    onClick: onClickLogo
  }), APP_CONFIGURATION.config.show_partner_logo && __jsx("div", {
    className: "flex flex-row flex-wrap items-center gap-[2px] md:gap-4 lg:-translate-x-[65px]"
  }, __jsx("p", {
    className: "text-[#5C5C5C] self-center tx-pxxs-regular"
  }, demoT("PARTNERED_WITH")), __jsx("div", {
    className: "relative w-[50px] h-[20px] md:w-[134px] md:h-[27px]"
  }, headerImage && __jsx(Image, {
    src: headerImage,
    alt: "Partner",
    fill: true,
    className: "object-contain"
  })))), __jsx("div", {
    className: "flex flex-row gap-4 h-full items-center justify-end"
  }, process.env.NEXT_PUBLIC_LANDING_RIDIRECT && !isMobile && __jsx("a", {
    onClick: async () => {
      setIsLoadingPage(true);
      muscleRouter.prefetch("/".concat(process.env.NEXT_PUBLIC_LANDING_RIDIRECT_URL));
      await new Promise(resolve => setTimeout(resolve, 1500));
      muscleRouter.push("/".concat(process.env.NEXT_PUBLIC_LANDING_RIDIRECT_URL));
    },
    className: "text-[#05BE50] tx-psm-semiBold cursor-pointer"
  }, "Conoce Benefit"), !isLoadingCustomer && !(pathname.includes('confirm_sign_up') || hideContent || maintenanceActive) ? __jsx(React.Fragment, null, customerIsLogged && (withEntityLogin && isSessionProviderActive || APP_CONFIGURATION.config.demo || forceShowPoints) ? __jsx("div", {
    className: cn("h-full")
  }, " ", __jsx(HeaderAvailablePointsDisplay, {
    allowRefreshPoints: APP_CONFIGURATION.config.allowRefreshPoints,
    smallDisplay: isTablet
  }), " ") : null, __jsx(React.Fragment, null, !customerIsLogged && !maintenanceActive && __jsx(HeaderAuthButtons, null), __jsx(HeaderActions, {
    customerIsLogged: customerIsLogged,
    additionalButtons: additionalButtons,
    additionalDropdownItems: additionalDropdownItems,
    allowUnauthenticatedCustomer: allowUnauthenticatedCustomer,
    smallDisplay: isTablet
  }))) : null))));
};
export default Header;